import { render, staticRenderFns } from "./SMSComposeButton.vue?vue&type=template&id=cc144bc0"
import script from "./SMSComposeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SMSComposeButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SMSComposeButton.vue?vue&type=style&index=0&id=cc144bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports